import { all, put, takeEvery } from 'redux-saga/effects';
import * as chartActions from '../chart/actions';
import * as drawActions from './actions';
import {
  CHARTIQ_DRAW_TOGGLE_DRAWING_TOOLBAR,
} from './constants';

function* toggleDrawingToolbar(params: any) {
  yield all([
    put(drawActions.toggleDrawing(params.payload)),
    put(chartActions.changeVectorParams(params.payload)),
  ]);
}

export function* sagaWatcher() {
  yield takeEvery(CHARTIQ_DRAW_TOGGLE_DRAWING_TOOLBAR, toggleDrawingToolbar);
}

const gens = [sagaWatcher()];
export default gens;
